import React from 'react'
import PropTypes from 'prop-types'

const Panel = ({formName, steps, currentStep}) => {
  const stepNumber = steps.indexOf(currentStep)

  const stepStateClass = panelIndex => {
    const isCurrentStep = stepNumber == panelIndex
    if (isCurrentStep) return ' active'

    return (stepNumber > panelIndex) ? ' completed' : ''
  }

  return <div className={`${formName}__panel`}>
    {steps.map((step, i) => {
      const stateClass = stepStateClass(i)

      return <div className='panel-step panel-left' key={i}>
        <div className={'step-number' + stateClass}>
          {stepNumber > i ? <i className='fa fa-check'></i> : <span>{`0${i + 1}`}</span>}
        </div>
        <div className={'step-name' + stateClass}>{step}</div>
      </div>
    })}
  </div>
}

Panel.propTypes = {
  formName: PropTypes.string.isRequired,
  steps: PropTypes.array.isRequired,
  currentStep: PropTypes.string.isRequired
}

export default Panel
